import fetch from "auth/FetchInterceptor";

const userService = {};

userService.get = function (params = {}) {
	return fetch({
		url: "/v1/rest/user",
		method: "get",
		params,
	});
};

userService.getUserInfo = function () {
	return fetch({
		url: "/v1/rest/user-info",
		method: "get",
	});
};

userService.getAllCompany = function (params = {}) {
	return fetch({
		url: "/v1/rest/user-list-all-company",
		method: "get",
		params,
	});
};

userService.post = function (data) {
	return fetch({
		url: "/v1/rest/user",
		method: "post",
		data: data,
	});
};

userService.put = function (id, data) {
	return fetch({
		url: `/v1/rest/user/${id}`,
		method: "put",
		data: data,
	});
};

userService.putProfile = function (id, data) {
	return fetch({
		url: `/v1/rest/user-profile/${id}`,
		method: "put",
		data: data,
	});
};

userService.verifyVerificationCode = function (data) {
	return fetch({
		url: `/v1/rest/verify-verification-code`,
		method: "post",
		data: data,
		headers: {
			"public-request": "true",
		},
	});
};

userService.putNovaSenha = function (data) {
	return fetch({
		url: `/v1/rest/user/new-pwd`,
		method: "put",
		data: data,
		headers: {
			"public-request": "true",
		},
	});
};

userService.getById = function (id) {
	return fetch({
		url: `/v1/rest/user/${id}`,
		method: "get",
	});
};

userService.desactivate = function (id, data) {
	return fetch({
		url: `/v1/rest/user/deactivate/${id}`,
		method: "put",
		data: data,
	});
};

userService.getInactiveReport = function (userId) {
	return fetch({
		url: `/v1/rest/user/${userId}/inactive-report`,
		method: "get",
	});
};

userService.reactivate = function (userId) {
	return fetch({
		url: `/v1/rest/user/reactivate/${userId}`,
		method: "put",
	});
};

userService.replaceInactive = function (payload) {
	return fetch({
		url: "/v1/rest/user/replace-inactive",
		method: "post",
		data: payload,
	});
};

userService.passwordChangeRequired = function (data) {
	return fetch({
		url: `/v1/rest/user/password-change-required`,
		method: "put",
		data: data,
		headers: {
			"public-request": "true",
		},
	});
};

export default userService;
